export const DTORBIT_URL = "https://dtorbit.com/";
